import {
  classNameParkerPrefix as prefixPk,
  classNamePrefix as prefixCt,
} from "@/utils/common";
import "./index.less";

const isContainsByTags = (node, tags) => {
  let { parentNode } = node;
  while (parentNode && parentNode.className !== prefixPk("view-container")) {
    if (tags.includes((parentNode.tagName || "").toLowerCase())) {
      return parentNode;
    }
    parentNode = parentNode.parentNode;
  }
  return false;
};

export default class minderRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("minder")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    const $img = node.querySelector("img") || node;
    const width = $img.getAttribute("data-width") || 0;
    const height = $img.getAttribute("data-height") || 0;
    node.style.width = `${width}px`;
    node.style.height = `${height}px`;

    // 处理浏览态向编辑态复制
    const attrs = ["src", "width", "height", "mss", "xml", "mssxml"];
    attrs.forEach((attr) => {
      node.setAttribute(
        `data-${attr}`,
        $img.getAttribute(`data-${attr}`) || ""
      );
    });
  };

  containerRender = ($container: HTMLElement, config) => {
    const imgs = $container.querySelectorAll(`.${prefixCt("minder")}>img`);
    const maxWidth = config.containerWidth || window.innerWidth;
    Array.from(imgs).forEach((img: any) => {
      if (!img.hasAttribute("data-src")) return;

      const dataWidth = parseInt(img.getAttribute("data-width"), 10);
      const parentNodeWithTable = isContainsByTags(img, ["td", "th"]);

      if (parentNodeWithTable || !dataWidth) {
        img.parentNode.style.cssText = "max-width: 100%";
      }

      if (dataWidth < maxWidth) {
        img.width = dataWidth;
        img.parentNode.style.cssText = `width: ${dataWidth}px`;
      } else {
        img.parentNode.style.cssText = "width: 100%;";
      }

      // 懒加载则先不设置src
      if (!config.lazyload) {
        img.src = img.getAttribute("data-src");
      }
      img.onerror = (e) => {
        e.target.classList.add(prefixCt("img-failed"));
      };
    });
  };
}
